module.exports = __webpack_public_path__ + "img/3-1-3.37020f43.svg";